import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormatHtml = () => (
  <ComponentDocs
    name="<FormatHtml/>"
    entry="FormatHtml"
    propsEntry="FormatHtmlProps"
  >
    <ComponentExample
      name="Formatted HTML"
      import={import("examples/Formatters/FormatHtml/FormattedHtmlExample")}
      rawImport={import(
        "examples/Formatters/FormatHtml/FormattedHtmlExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormatHtml;
